import React from 'react'
import { useNavigate } from 'react-router-dom'
import Pagination from '../layout/Pagination'
import { canManageClients } from '../global_context/capabilities/clientCapabilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import ReactFilter from '../components/inputs/ReactFilterList'
import { Table } from 'react-bootstrap'
import LoadingScreen from '../components/LoadingScreen'

const ClientIndexView = ({
  title,
  data,
  filters,
  isFetching,
  searchInput,
  onSearch,
  onSearchKeyPress,
  resetReactFilters,
  isAnyFilterSelected,
  updateAllSelectedOptions,
  pagination,
  resetFilters,
  handlePaginationClick
}) => {
  const navigate = useNavigate()

  const redirectToCreateClient = () => {
    navigate('/crear_cliente')
  }

  const showModel = (event) => {
    event.preventDefault()
    const id = event.target.id
    window.open(`/clientes/${id}/detalles`, '_blank')
  }

  const filtersArray = Array.isArray(filters) ? filters : Array.from(filters || [])
  const anyFilterEmpty = filtersArray.some((filter) => !filter?.value || filter.value.length === 0)

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      <div className="index-header detailed-container">
        <h2>{title}</h2>
        <div className="index-buttons">
          {canManageClients() && (
            <button onClick={redirectToCreateClient}>Crear cliente nuevo</button>
          )}
        </div>
      </div>

      <div className="index-table">
        <div className="show-area">
          <h4 className="text-sub-title">Filtrar clientes por:</h4>

          <div className="filters-search-container mb-10">
            <FontAwesomeIcon className="filter-icon mr-10" icon={faFilter} />
            <div className="filters-container">
              {filtersArray?.map((filter, indx) => (
                <div key={`flr-${indx}`} className="mr-10">
                  <ReactFilter
                    className="mr-10"
                    title={filter.key}
                    identifier={filter.key}
                    options={filter.value}
                    resetWatcher={resetReactFilters}
                    onSelectionChange={updateAllSelectedOptions}
                    disabled={anyFilterEmpty}
                  />
                </div>
              ))}
            </div>

            <div className="search-input-containter">
              <input
                value={searchInput}
                onChange={onSearch}
                onKeyDown={onSearchKeyPress}
                className="round-search-input search-icon-font-client"
                placeholder="Buscar por código o nombre de cliente"
              />
              {searchInput === '' && (
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="search-icon-client"
                />
              )}
              {searchInput && (
                <div title="Limpiar texto" onClick={resetFilters} className="round-search-input-x">
                  X
                </div>
              )}
            </div>
          </div>

          <div className="mb-20">
            {isAnyFilterSelected && (
              <a onClick={resetFilters} className="reset-filter cursor-pointer mb-20">
                Restablecer filtros aplicados
              </a>
            )}
          </div>

          <Table hover responsive>
            <thead className="table-header-gray">
              <tr>
                <th className="col-small-client">
                  <span className="th-header-text">CÓDIGO</span>
                </th>
                <th className="col-medium-client">
                  <span className="th-header-text">NOMBRE DEL CLIENTE</span>
                </th>
                <th className="col-large-client">
                  <span className="th-header-text">LISTA DE PRECIO ASIGNADA</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((model, index) => (
                  <tr key={index}>
                    <td id={model.id} onClick={showModel} className="table-body-cell">
                      {model.db_ref}
                    </td>
                    <td id={model.id} onClick={showModel} className="table-body-cell">
                      {model.name || 'SIN ASIGNAR'}
                    </td>
                    <td id={model.id} onClick={showModel} className="table-body-cell">
                      {model.price_list || 'SIN ASIGNAR'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No hay resultados</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {pagination.total_pages > 1 && (
        <nav className="index-table" onClick={handlePaginationClick}>
          <Pagination
            current_page={pagination.current_page}
            total_pages={pagination.total_pages}
          />
        </nav>
      )}
    </>
  )
}

export default ClientIndexView
